import AppBar from '@material-ui/core/AppBar';
import Divider from '@material-ui/core/Divider';
import DrawerWrapper from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { useContext, useState } from 'react';

import { DRAWER_TABS } from '../../../constants';
import { authContext } from '../../../contexts';
import { AvatarMenu } from '../components';

type DrawerProps = {
  selectedTab: DRAWER_TABS;
  setSelectedTab: (tab: DRAWER_TABS) => void;
  children?: JSX.Element;
};

const drawerWidth = 200;
const drawerTabs = [
  {
    tabName: DRAWER_TABS.PATIENTS,
    tabText: 'Patients',
    tabIconPath:
      'M9 3C9 1.34 10.34 0 12 0C13.66 0 15 1.34 15 3C15 4.66 13.66 6 12 6C10.34 6 9 4.66 9 3ZM12 2C12.55 2 13 2.45 13 3C13 3.55 12.55 4 12 4C11.45 4 11 3.55 11 3C11 2.45 11.45 2 12 2ZM6 5C6 6.1 5.1 7 4 7C2.9 7 2 6.1 2 5C2 3.9 2.9 3 4 3C5.1 3 6 3.9 6 5ZM4 8C4.39 8 4.76 8.04 5.13 8.1C4.73 8.78 4.5 9.56 4.5 10.39V12H0V10.43C0 9.62 0.48 8.9 1.22 8.58C2.07 8.21 3.01 8 4 8ZM20 7C21.1 7 22 6.1 22 5C22 3.9 21.1 3 20 3C18.9 3 18 3.9 18 5C18 6.1 18.9 7 20 7ZM22.78 8.58C23.52 8.9 24 9.62 24 10.43V12H19.5V10.39C19.5 9.56 19.27 8.78 18.87 8.1C19.24 8.04 19.61 8 20 8C20.99 8 21.93 8.21 22.78 8.58ZM16.24 7.65C15.07 7.13 13.63 6.75 12 6.75C10.37 6.75 8.93 7.14 7.76 7.65C6.68 8.13 6 9.21 6 10.39V12H18V10.39C18 9.21 17.32 8.13 16.24 7.65ZM8.07857 9.97797L8.07 10H15.93L15.9174 9.97083C15.8252 9.75605 15.757 9.59716 15.02 9.31C14.05 8.93 13.03 8.75 12 8.75C10.97 8.75 9.95 8.93 8.98 9.31C8.22514 9.60033 8.16335 9.75954 8.07857 9.97797Z',
  },
  {
    tabName: DRAWER_TABS.CARE_PROVIDERS,
    tabText: 'Care Providers',
    tabIconPath:
      'M16 0H2C0.9 0 0.01 0.9 0.01 2L0 16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM16 16H2V2H16V16ZM10.5 14H7.5V10.5H4V7.5H7.5V4H10.5V7.5H14V10.5H10.5V14Z',
  },
  {
    tabName: DRAWER_TABS.ADMINS,
    tabText: 'Admins',
    tabIconPath:
      'M1 0H17V2H1V0ZM15.96 8L15.36 5H2.64L2.04 8H15.96ZM17 3H1L0 8V10H1V16H11V10H15V16H17V10H18V8L17 3ZM3 10V14H9V10H3Z',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: 'white',
    color: 'black',
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarCaption: {
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '21.09px',
    letterSpacing: '0.1px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  menuIcon: {
    padding: 0,
    marginRight: '30px',
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    zIndex: 1,
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7) + 1,
    },
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  selectedTab: {
    color: theme.palette.primary.main,
    fill: theme.palette.primary.main,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  drawerItem: {
    color: theme.palette.text.secondary,
  },
  avatarMenu: {
    display: 'flex',
    flexDirection: 'column',
  },
}));

const DrawerTabs: React.FC<DrawerProps> = ({ selectedTab, setSelectedTab }) => {
  const classes = useStyles();

  return (
    <>
      {drawerTabs.map((tab) => {
        const { tabName, tabText, tabIconPath } = tab;
        const iconClassName =
          selectedTab === tabName ? classes.selectedTab : classes.drawerItem;

        return (
          <ListItem
            className={classes.listItem}
            button
            key={tabName}
            onClick={() => setSelectedTab(tabName)}>
            <ListItemIcon>
              <SvgIcon className={iconClassName}>
                <path d={tabIconPath} />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText className={iconClassName} primary={tabText} />
          </ListItem>
        );
      })}
    </>
  );
};

export const Drawer: React.FC<DrawerProps> = ({
  selectedTab,
  setSelectedTab,
  children,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const { me } = useContext(authContext);
  const [open, setOpen] = useState<boolean>(true);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}>
        <Toolbar>
          <Grid xs item className={classes.header}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuIcon, {
                [classes.hide]: open,
              })}>
              <MenuIcon />
            </IconButton>
            <Typography className={classes.appBarCaption} noWrap>
              {'Halterix - ' + me?.clinicName}
            </Typography>
          </Grid>
          <Grid className={classes.avatarMenu}>
            <AvatarMenu />
          </Grid>
        </Toolbar>
      </AppBar>
      <DrawerWrapper
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}>
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          <DrawerTabs
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </List>
      </DrawerWrapper>
      {children}
    </div>
  );
};
